module.exports = "images/get-inspired-2.webp";